import { useMutation, useQuery } from "@tanstack/react-query";

import {
  gql,
  GraphQLAPI,
  GraphQLResult,
  queries,
  WorkspaceWithLicense,
} from "@examspark/api";
import { Workspace } from "@examspark/types";

export const useQueryListUserWorkspaces = (params: {
  userId?: string;
  appId?: string;
  primaryOnly?: boolean;
}) => {
  return useQuery<WorkspaceWithLicense[]>({
    enabled: !!params.userId && !!params.appId,
    queryKey: ["workspaces", params.userId, params.primaryOnly],
    queryFn: async () => {
      const result = await gql.operations.user.listUserWorkspaces(params);
      return result ?? [];
    },
  });
};

export const useMutationDeleteWorkspaceUser = () => {
  return useMutation({
    mutationFn: async (input: { workspaceId: string; userId: string }) => {
      const result = await gql.operations.workspace.deleteWorkspaceUser(
        input.workspaceId,
        input.userId,
      );
      return result ?? [];
    },
  });
};

export const useMutationLeaveWorkspace = () => {
  return useMutation({
    mutationFn: async (input: { workspaceId: string; userId: string }) => {
      const result = await gql.operations.workspace.leaveWorkspace(input);
      return result ?? [];
    },
  });
};

export const useQueryGetWorkspaceUser = (
  workspaceId?: string,
  userId?: string,
) => {
  return useQuery({
    enabled: !!workspaceId && !!userId,
    queryKey: ["workspace-user", workspaceId, userId],
    queryFn: async () => {
      const result = (await GraphQLAPI.query({
        query: queries.workspace.getWorkspaceUser({
          label: "GetWorkspaceUser",
          fields: `
            id
            sk
            name
            description
            createdAt
            updatedAt
            lastActiveAt
            acl
            appLicenses {
              appId
              appKey
            }
            isDisabled
            roles {
              name
              description
              acl
            }
            user {
              id
              sk
              firstName
              lastName
              avatarHash
            }
            workspace {
              id
              sk
              name
              description
              acl
            }
        `,
        }),
        variables: {
          input: {
            id: workspaceId,
            sk: `workspace-user#${userId}`,
          },
        },
      })) as GraphQLResult<{
        getWorkspace: Workspace;
      }>;

      return result.data?.getWorkspace;
    },
  });
};
